import { render, staticRenderFns } from "./ServicioSocialPage.vue?vue&type=template&id=2afb725c&scoped=true&"
import script from "./ServicioSocialPage.vue?vue&type=script&lang=js&"
export * from "./ServicioSocialPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb725c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialPage.vue
// module id = 217
// module chunks = 11